import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { OrderShuttleService } from '../../services/ordershuttle.service';
import { OrderShuttleVM } from '../../models/orderModel';
import moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { MyConfigOrganization } from '../../models/myConfig';
import { Router } from '@angular/router';

@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DashboardComponent implements OnInit, OnDestroy {
  componentDestroyed$: Subject<boolean> = new Subject();
  @Input() organization: MyConfigOrganization
  intervalId: any;

  lastReload = new Date();
  orderShuttlesPickupArrival: OrderShuttleVM[] = [];
  orderShuttlesPickupDeparture: OrderShuttleVM[] = [];
  orderShuttlesOtherArrival: OrderShuttleVM[] = [];
  orderShuttlesOtherDeparture: OrderShuttleVM[] = [];

  totalArrivalOrders: number = 0;
  totalArrivalPickups: number = 0;
  totalArrivalPersons: number = 0;

  totalDepartureOrders: number = 0;
  totalDeparturePickups: number = 0;
  totalDeparturePersons: number = 0;

  displayedColumnsArrival: string[] = ['name', 'orderNr', 'time', 'terminal', 'orderParkingParkingSiteName', 'passengers'];
  displayedColumnsDeparture: string[] = ['name', 'orderNr', 'time', 'orderParkingParkingSiteName', 'terminal', 'passengers'];

  constructor(
    public authService: AuthService,
    public orderShuttleService: OrderShuttleService,
    public router: Router
  ) { }

  ngOnInit() {
    this.refreshData();
    this.intervalId = setInterval(() => this.refreshData(), 30000);
  }

  refreshData() {
    if (this.authService.loggedIn()) {
      this.getOrderShuttlesOther();
    }
  }

  getOrderShuttlesPickup(orderShuttles: OrderShuttleVM[]) {

    let pickups = orderShuttles.filter(s => s.status === 'ReadyForPickup');

    pickups.forEach(orderShuttle => {
      orderShuttle.shuttleDateNew = this.getNewTime(orderShuttle);
      orderShuttle.isReadyForPickup = this.getIsReadyForPickup(orderShuttle)
    });

    this.orderShuttlesPickupArrival = [];
    this.orderShuttlesPickupDeparture = [];

    pickups.sort(
      function (a, b) {
        return new Date(a.shuttleDateNew).valueOf() - new Date(b.shuttleDateNew).valueOf();
      }
    ).forEach(orderShuttle => {

      if (orderShuttle.productType == 'ShuttleDeparture') {
        if (moment(orderShuttle.shuttleDate) == moment(orderShuttle.shuttleDateNew)) {
          orderShuttle.shuttleDateNew = null;
        }
        this.orderShuttlesPickupDeparture.push(orderShuttle);
      }

      if (orderShuttle.productType == 'ShuttleArrival') {
        orderShuttle.shuttleDateNew = this.getNewTime(orderShuttle);
        this.orderShuttlesPickupArrival.push(orderShuttle);
      }
    });

    this.orderShuttlesPickupDeparture.sort(
      function (a, b) {
        return new Date(a.shuttleUpdated).valueOf() - new Date(b.shuttleUpdated).valueOf();
      }
    );

    this.totalArrivalPickups = this.orderShuttlesPickupArrival.length;
    this.totalArrivalPersons = this.orderShuttlesPickupArrival.reduce((acc, current) => acc + current.passengers, 0);

    this.totalDeparturePickups = this.orderShuttlesPickupDeparture.length;
    this.totalDeparturePersons = this.orderShuttlesPickupDeparture.reduce((acc, current) => acc + current.passengers, 0);

    this.lastReload = new Date();
  }

  getNewTime(orderShuttle: OrderShuttleVM): Date {
    var compareDates: Date[] = [];
    if (orderShuttle.arrivalId) {

      let addMinutes = 25;
      let addMinutesBaggageArrived = 15;
      if (orderShuttle.baggage > 0) {
        addMinutes = 45;
      }

      if (orderShuttle.arrivalVM.status == 'New' || orderShuttle.arrivalVM.status == 'Scheduled' || orderShuttle.arrivalVM.status == 'Active' || orderShuttle.arrivalVM.status == 'Deleted' || orderShuttle.arrivalVM.status == 'Cancelled') {
        if (orderShuttle.arrivalVM.actualArrival) {
          compareDates.push(moment(orderShuttle.arrivalVM.actualArrival).add(addMinutes, 'm').toDate());
        } else if (orderShuttle.arrivalVM.estimatedArrival) {
          compareDates.push(moment(orderShuttle.arrivalVM.estimatedArrival).add(addMinutes, 'm').toDate());
        } else if (orderShuttle.arrivalVM.scheduledArrival) {
          compareDates.push(moment(orderShuttle.arrivalVM.scheduledArrival).add(addMinutes, 'm').toDate());
        }
      }

      if (orderShuttle.arrivalVM.status == 'Landed' || orderShuttle.arrivalVM.status == 'FirstBaggage' || orderShuttle.arrivalVM.status == 'LastBaggage') {
        if (orderShuttle.arrivalVM.firstBag) {
          compareDates.push(moment(orderShuttle.arrivalVM.firstBag).add(addMinutesBaggageArrived, 'm').toDate());
        } else if (orderShuttle.arrivalVM.actualArrival) {
          compareDates.push(moment(orderShuttle.arrivalVM.actualArrival).add(addMinutes, 'm').toDate());
        }
      }
      if (compareDates.length > 1) {
        return compareDates.reduce(function (a, b) { return a > b ? a : b; });
      }
      else {
        return compareDates[0];
      }
    }
    return new Date(orderShuttle.shuttleDate);
  }

  getIsReadyForPickup(orderShuttle: OrderShuttleVM): boolean {
    if (orderShuttle.arrivalVM) { //Flight exists
      if (orderShuttle.baggage > 0) { //Has Baggage
        if (orderShuttle.arrivalVM.firstBag != null) { //Firstbag set
          var firstBag = moment(orderShuttle.arrivalVM.firstBag);
          if (firstBag.isSameOrBefore(moment())) { //Firstbag is before now
            return true
          }
          else { //Firstbag is after now
            return false;
          }
        }
        else { //Firstbag not set yet
          return false;
        }
      }
      else { //No Baggage
        var pickupTime = moment(orderShuttle.shuttleDateNew).subtract(30, 'minutes');
        return pickupTime.isSameOrBefore(moment());
      }
    }
    else { //Flight does not exis
      var pickupTime = moment(orderShuttle.shuttleDateNew).subtract(30, 'minutes');
      return pickupTime.isSameOrBefore(moment());
    }
  }

  getOrderShuttlesOther() {
    let orderShuttlesOtherNewArrival: OrderShuttleVM[] = [];
    let orderShuttlesOtherNewDeparture: OrderShuttleVM[] = [];

    const dateFrom = moment(moment().format('YYYY-MM-DD') + 'T00:00').add(-12, 'hours');
    const dateTo = moment(moment().format('YYYY-MM-DD') + 'T23:59').add(12, 'hours');

    this.orderShuttleService
      .getOrderShuttlesPaidOrganizationBetweenShuttleDate('A848CCD3-FD8D-4035-925E-571EBB4E93E8', dateFrom.format('YYYY-MM-DDTHH:mm'), dateTo.format('YYYY-MM-DDTHH:mm'))
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(orderShuttles => {
        this.getOrderShuttlesPickup(orderShuttles);

        let noPickups = orderShuttles.filter(s => s.status !== 'ReadyForPickup');
        noPickups.forEach(orderShuttle => {

          if (orderShuttle.status == 'Paid') {
            if (orderShuttle.productType == 'ShuttleDeparture') {
              orderShuttlesOtherNewDeparture.push(orderShuttle);
            }

            if (orderShuttle.productType == 'ShuttleArrival') {
              orderShuttle.shuttleDateNew = this.getNewTime(orderShuttle);
              orderShuttlesOtherNewArrival.push(orderShuttle);
            }
          }
        });

        this.orderShuttlesOtherArrival = [];
        this.orderShuttlesOtherDeparture = [];

        orderShuttlesOtherNewDeparture.sort(
          function (a, b) {
            return new Date(a.shuttleDate).valueOf() - new Date(b.shuttleDate).valueOf();
          }
        ).forEach(orderShuttle => {
          this.orderShuttlesOtherDeparture.push(orderShuttle);
        });

        orderShuttlesOtherNewArrival.sort(
          function (a, b) {
            return new Date(a.shuttleDateNew).valueOf() - new Date(b.shuttleDateNew).valueOf();
          }
        ).forEach(orderShuttle => {
          if (moment(orderShuttle.shuttleDate) == moment(orderShuttle.shuttleDateNew)) {
            orderShuttle.shuttleDateNew = null;
          }
          this.orderShuttlesOtherArrival.push(orderShuttle);
        });
        this.lastReload = new Date();
      });
  }

  displayRouteName(orderShuttle: OrderShuttleVM): string {
    let routeName = orderShuttle.routeName;
    if (routeName == 'Från Arlanda till Arlanda XPO Apartments') {
      return 'XPO';
    }
    if (routeName == 'Från Arlanda XPO Apartments till Arlanda') {
      return 'XPO';
    }
    if (routeName == 'Från Arlanda till Scandic') {
      return 'Scandic';
    }
    if (routeName == 'Från Scandic till Arlanda') {
      return 'Scandic';
    }
    if (routeName == 'Från Hotel till Arlanda' || routeName == 'Från Arlanda till Hotell') {
      const hotelMap: Record<string, string> = {
        '417596F5-8FE5-4FA7-84DC-0AF0ACE72CF1': 'Scandic',
        '5BF79F25-27BF-4B5B-AF83-B4A0233DAB70': 'ApartDirect',
        '39218780-069A-4C6B-9925-22365A075C15': 'Quality',
        'D6B9D8C6-8FB5-41A5-AC2E-B3FC007A8251': 'Aiden'
      };
      return hotelMap[orderShuttle.organizationId.toUpperCase()] || '';
    }

    return routeName;
  }

  displayHotelName(orgId: string): string {
    if (orgId == '942ce067-7848-4441-b746-8f6eed7395bb') {
      return 'Quality';
    }
    return '';
  }

  removeLastPart(text) {
    const lastColonIndex = text.lastIndexOf(":");
    return lastColonIndex !== -1 ? text.slice(0, lastColonIndex) : text;
  }

  isHotel(orderShuttle: OrderShuttleVM): boolean {
    if (!orderShuttle || !orderShuttle.organizationId) return false;

    const hotelOrgIds = [
      '417596f5-8fe5-4fa7-84dc-0af0ace72cf1', // Scandic
      '5bf79f25-27bf-4b5b-af83-b4a0233dab70', // ApartDirect
      '39218780-069a-4c6b-9925-22365a075c15', // Quality
      '942ce067-7848-4441-b746-8f6eed7395bb', // Quality XPO
      'd6b9d8c6-8fb5-41a5-ac2e-b3fc007a8251', // Aiden
      '55d7084d-3cf0-4ccc-9448-f924afcdf3bc'  // Aiden Short Term
    ];

    return hotelOrgIds.includes(orderShuttle.organizationId.toLowerCase());
  }

  isRedKeyStatus(status: string): boolean {
    return [
      'FromCustomerManualToDo',
      'FromCustomerAutomatedNoKey',
      'ToCustomerManualToDo',
      'ToCustomerAutomatedNoKey'
    ].includes(status);
  }

  isGreenKeyStatus(status: string): boolean {
    return [
      'FromCustomerManualDone',
      'FromCustomerAutomatedKeyIn'
    ].includes(status);
  }

  goToOrder(orderId: string): void {
    // const url = this.router.serializeUrl(this.router.createUrlTree([`/admin/back-office24-order/${orderId}`]));
    // window.open(url, '_blank');
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
